import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "block-wrapper" }
const _hoisted_3 = { class: "block first" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row-value" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row-value" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row-value" }
const _hoisted_10 = { class: "block second" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "row-value" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "row-value" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.lot && $props.lot.option)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "header" }, "Call Option", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-title" }, "Option holder:", -1)),
              _createElementVNode("div", _hoisted_5, _toDisplayString($props.lot.option.optionHolder), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-title" }, "Option Starts:", -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString($setup.formatDate($props.lot.option.termsOfOption.optionStartDate)), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-title" }, "Option Ends:", -1)),
              _createElementVNode("div", _hoisted_9, _toDisplayString($setup.dayjs($props.lot.option.termsOfOption.optionEndDate).isValid() ? $setup.formatDate($props.lot.option.termsOfOption.optionEndDate) : $props.lot.option.termsOfOption.optionEndDate), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-title" }, "Land price:", -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString($setup.formatPrice($props.lot.option.termsOfOption.landPrice)), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-title" }, "Option Fee:", -1)),
              _createElementVNode("div", _hoisted_14, _toDisplayString(`${$setup.formatPrice($props.lot.option.termsOfOption.optionFee.fee)} (${$props.lot.option.termsOfOption.optionFee.percent}%)`), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-title" }, "Conditions:", -1)),
              _createElementVNode("div", _hoisted_16, _toDisplayString($props.lot.option.termsOfOption.conditions), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}